import { CLEAR_DEEPLINK, SAVE_DEEPLINK } from '../../actionTypes';

export const saveDeeplink = (data) => {
  return {
    type: SAVE_DEEPLINK,
    payload: {
      data,
    },
  };
};

export const clearDeeplink = () => {
  return {
    type: CLEAR_DEEPLINK,
  };
};
